import ControllerBase from './../../../../global/js/ControllerBase';
import { AtomButtonEvents } from 'wolf/components/atoms/a-button/a-button.events';

export default class ControllerSearchFilter extends ControllerBase {
	/** A list of dom element references available to this component */
	private readonly componentRefs = {
		searchBox: 'searchBox',
		// searchButton: 'searchButton',
		searchForm: 'searchForm',
	};

	private searchUrl: string;

	constructor(element: HTMLElement) {
		super(element);

		this.searchUrl = element.dataset.searchurl ?? '';
		// this.observeSearchButtonClick();
	}

	/**
	 * Handle synthetic form submits using an a-button component (instead of an input type=submit)
	 * @returns void
	 */
	// private observeSearchButtonClick(): void {
	// 	const buttonAtomComponent = this.$references[this.componentRefs.searchButton]!.firstChild;
	// 	const form = this.$references[this.componentRefs.searchForm] as HTMLFormElement;
	//     if (form && buttonAtomComponent) {
	//         buttonAtomComponent.addEventListener(AtomButtonEvents.buttonClicked, (e: CustomEvent<Event | MouseEvent>) => {
	//             if (e && e.detail) {
	// 				e.preventDefault();

	// 				// submit the form
	// 				form && form.submit();
	//             }
	//         });
	//     }
	// }
}
